import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aviso',
  templateUrl: './aviso.component.html',
  styleUrls: ['./aviso.component.scss']
})
export class AvisoComponent implements OnInit {

  public openAviso: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  ToggleAviso() {
    this.openAviso = !this.openAviso;
  }

}
